'use client'
import PropTypes from 'prop-types'
import { Typography, CircularProgress } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { ReactComponent as EmptyImageIcon } from 'app/components/icons/empty-image-icon.svg'
import ContainedButton from 'app/componentV4/Button/ContainedButton'
import { SECONDARY } from 'app/constants/button'
import { FormattedMessage } from 'react-intl'

const useStyles = makeStyles((theme) => ({
  container: {
    textAlign: 'center',
    padding: theme.spacing(4, 2),
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginBottom: theme.spacing(3),
    '& svg': {
      width: 64,
      height: 64,
      // opacity: 0.6,
    },
  },
  text: {
    marginBottom: theme.spacing(3),
    maxWidth: 300,
    margin: '0 auto',
    color: theme.colors['primary-300'],
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(2),
  },
  loadingContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(2),
  },
}))

export default function PhotoGalleryEmpty({ onAddImage }) {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <div className={classes.iconContainer}>
        <EmptyImageIcon />
      </div>
      <Typography className={classes.text}>
        <FormattedMessage id="profile.photo.gallery.empty" />
      </Typography>
      <div className={classes.buttonContainer}>
        <ContainedButton color={SECONDARY} onClick={onAddImage} size="medium">
          <FormattedMessage id="profile.photo.gallery.add.btn" />
        </ContainedButton>
      </div>
    </div>
  )
}

PhotoGalleryEmpty.propTypes = {
  onAddImage: PropTypes.func.isRequired,
}
